
<template>
  <svg width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="m11.998 17l7-8h-14z"></path></svg>
</template>

<script>
export default {
  name: 'CaretDown'
}
</script>